module.exports = __webpack_public_path__ + "img/icon_error_pink.e1bfe3c2.svg";